import thomDropdown from "../../modules/dropdown/dropdown";

jQuery = $;
export default function wineDetail() {
    if (typeof window.cdbWineDetParams !== 'undefined' && $('.thom-dropdown--options-item').length) {
        var options = {
            areaClub_URL: window.cdbWineDetParams.areaClub_URL ? window.cdbWineDetParams.areaClub_URL : '/',
            wineDetail_API_URL: window.cdbWineDetParams.wineDetail_API_URL ? window.cdbWineDetParams.wineDetail_API_URL : '/'
        }

        // Dropdown init
        thomDropdown();
        // Add click event
        $('.thom-dropdown--options-item').off('click').on('click', function () {
            let selWineInfoID = $(this).attr("data-wine-info-id"); // wineInfoID selezionato (prossimo)
            let selWineInfoName = $(this).attr("data-wine-name"); // wineName selezionato (prossimo)
            let selYear = $(this).html(); // annata selezionata (prossimo)
            let currentWineInfoID = $('#currentWineInfoID').val(); // wineInfoID corrente
            let wineId = $(this).attr("data-wine-id"); // ID del vino
            if (selWineInfoID === 'X') {
                // Altre annate -> Area Club
                window.location.href = options.areaClub_URL;
            } else {
                if (currentWineInfoID !== selWineInfoID) {
                    $('.thom-dropdown--label-item').html(selYear);
                    var $wineName = $('#wine-details-ajax [data-role="wineName"]');
                    if ($wineName.length) {
                        $wineName.html(selWineInfoName);
                    }
                    $("#wine-details-ajax .ajax-content").animate({opacity: 0}, 300, function () {
                        $.ajax({
                            url: options.wineDetail_API_URL + selWineInfoID + "/" + wineId,
                            type: 'GET',
                        })
                            .done(function (data) {
                                $('#currentWineInfoID').val(selWineInfoID);
                                if (data.content) {
                                    $("#wine-details-ajax .ajax-content").replaceWith(data.content);
                                    $("#wine-details-ajax").animate({opacity: 1}, 300);
                                }
                            });
                    });
                }
            }
        });
    }
}